import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import { CLAIMS_AUTO_AI_MODEL } from "../lib/claimsAiModels";

const DEFAULT_MODEL: string = CLAIMS_AUTO_AI_MODEL;

/**
 * Hook to read the centralized AI model setting from claims_settings.
 * Returns the selected model identifier string.
 */
export function useAiModel() {
    const [aiModel, setAiModel] = useState(DEFAULT_MODEL);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await supabase
                    .from("claims_settings")
                    .select("setting_value")
                    .eq("setting_key", "ai_model")
                    .single();
                if (data?.setting_value) {
                    setAiModel(data.setting_value);
                }
            } catch {
                // Silently use default
            }
        })();
    }, []);

    return aiModel;
}
